<style lang="scss">
    .valuation .ivu-checkbox-wrapper{
        font-size: 12px;
    }
    .valuation .ivu-collapse-content{
        padding: 0 0 0 16px !important;
    }
    .reciveoffer .ivu-table{
        font-size: 12px !important;
    }
    .reciveoffer .ivu-table-cell{
        padding-left: 5px !important;
        padding-right: 5px !important;
    }
    .reciveoffer td.ivu-table-expanded-cell{
        padding: 0px !important;
    }
    .reciveoffer td.ivu-table-expanded-cell{
        padding: 0px !important;
        border: none !important
    }

    .reciveoffer td.ivu-table-expanded-cell .ivu-table-wrapper-with-border{
        border: none !important
    }
    .reciveoffer .itemtable .ivu-table-border td:last-child{
        border-right: none !important;
    }
</style>
<template>
    <div>
        <compWrapper title="基本信息">
            <Form 
                class="valuation margin-15"
                :model="formData"
                :rules="rules"
                ref="validForm"
                :labelWidth="100">
                <FormItem v-if="type!='add'" label="方案代码" >
                    <div>{{formData.code}}</div>
                </FormItem>  
                <FormItem label="方案名称" prop="name" v-if="type!='query'">
                    <Input v-model="formData.name"></Input>
                </FormItem>  
                <FormItem label="方案名称" v-if="type=='query'">
                    <div>{{formData.name}}</div>
                </FormItem>  
                <FormItem label="描述" v-if="type!='query'">
                    <Input v-model="formData.description"></Input>
                </FormItem>  
                <FormItem label="描述" v-if="type=='query'">
                    <div>{{formData.description}}</div>
                </FormItem>  
                
            </Form>
            <Form
                class="valuation margin-15"
                ref="validForm"
                :labelWidth="100">
                <FormItem label="方案配置" v-if="type!='query'">
                    <div class="margin-bottom-15">
                        <Button v-if="isShowEditDetail" @click="showEditDetail('open')">全部展开</Button>
                        <Button v-else @click="showEditDetail">全部折叠</Button>
                    </div>
                    <Row class="margin-top-10 reciveoffer">
                        <Col span="24" >
                            <Table
                                :columns="columns"
                                :data="newDatalist"
                                :key="(sindx+1)"
                                size="small"
                                ref="tabledoc"
                                max-height="500"
                                border>
                            </Table>
                        </Col>
                    </Row>
                </FormItem>   
                <FormItem label="方案配置" v-if="type=='query'">
                    <div class="margin-bottom-15">
                        <Button v-if="isShowDetail" @click="showDetail">全部展开</Button>
                        <Button v-else @click="showDetail">全部折叠</Button>
                    </div>
                    <div class="reciveoffer">
                        <Table
                            :columns="columns"
                            :data="dataList"
                            :key="(sindx+1)"
                            size="small"
                            ref="tabledoc"
                            max-height="500"
                            border>
                        </Table>
                    </div>
                </FormItem>
            </Form>
            <vButtonGroup class="text-right" v-if="type!='query'" slot="footer">
                <Button type="primary" @click="submit">确认</Button>
                <Button class="margin-left-10" @click="cancel">取消</Button>
            </vButtonGroup>
        </compWrapper>

        <!-- 弹框 -->
        <compModal
        v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show=false"
        >
            <component ref="cusref" :is="modalProps.component" v-bind="modalProps" v-on="modalProps.on" ></component>
        </compModal>
        
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { HttpQueryValuationOne, HttpSaveValuationOne,HttpGetCategoryType } from "@/service/tasks";
import mixin from '../../newbigaccount/minxin';
import compLine from './linetable.vue'
export default {
    mixins: [mixin],
    props:['querytype','activeid'],
    components:{compLine},
    data(){
        return {
            type:this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeid,
            formData:{
                name:''
            },
            openValue:'',
            categoryList: [],
            loading:false,
            checkAll:false,
            indeterminate:null,
            rules: {
                name: [
                    {
                        required: true,
                        message: "该项不能为空，请填写",
                        // trigger: 'blur'
                    },
                ],
            },
            chooseIndex:-1,
            biddingStage:[],
            billingPlanCategoryList:[],
            dataList:[],
            modalProps:{},
            newarr:[],
            newDatalist:[],
            sindx:0,
            isShowDetail:false,
            isShowEditDetail:false,
        }
    },
    created(){
        HttpGetCategoryType({expenseCategoryType:0,billingChannel:-1}).then(res=>{
            this.categoryList = res.data.map(item=>{
                return {
                    value:item.id,
                    label:item.name+'('+item.code+')',
                    attach:{
                        code:item.code
                    }
                }
            })
            this.newarr = this.categoryList.concat()
        })
        // this.dataList = this.getOrderList
    },
    mounted(){
        this.getDetail()

    },
    computed:{
        columns(){
            let datalist1 = [
                {
                    type: 'expand',
                    width: 50,
                    render: (h, {row}) => {
                        
                        return <Table border class="itemtable font-12" columns={this.itemcolumns} show-header={false} data={row.items||[]}></Table>
                    }
                },
                {
                    title: '单据类型',
                    key: 'orderType',
                    align:'center',
                    render:(h,{row})=>{
                        if(this.type == 'query'){
                            let ajson = this.getOrderList.filter(item=>{
                                return item.value === row.orderType
                            })[0].label
                            return <div>{ajson}</div>
                        }else{
                            let ajson = this.getOrderList.filter(item=>{
                                return item.value === row.value
                            })[0].label
                            return <div>{ajson}</div>
                        }
                    }
                },
                {
                    title: '计费项目',
                    align:'center',
                    render:(h,{row})=>{
                        return <div>--</div>
                    }
                },
                {
                    title: '操作',
                    align:'center',
                    render:(h, { row, index })=>{
						return h('div', [
                            h('Button', {
                                props: {
                                    size: 'small',
                                    type:'info',
                                },
                                on: {
                                    click: () => {
                                        this.clickProject(row,index)
                                    }
                                },
                            }, '编辑')
                        ])
					}
                },
            ]
            if(this.type=='query'){
                return datalist1.splice(0,3)
            }else{
                return datalist1
            }
        },
        itemcolumns(){
            let datalist2 = [
                {
                    title: 'index',
                    width: 50,
                },
                {
                    title: '单据类型',
                    align:'center',
                    render:(h,{row})=>{
                        return <div>--</div>
                    }
                },
                {
                    title: '计费项目',
                    align:'center',
                    render:(h,{row})=>{
                        if(row.billingCategoryId){
                            return <div>{this.getCostName(row)}</div>
                        }
                    }
                },
                {
                    title: '操作',
                    align:'center',
                    render:(h, { row, index })=>{
						return h('div', [
                            h('Button', {
                                props: {
                                    theme: "error",
                                    size: 'small',
                                },
                                on: {
                                    click: () => {
                                        this.deleteProject(row,index)
                                    }
                                },
                            }, '删除')
                        ])
					}
                },
            ]
            if(this.type=='query'){
                return datalist2.splice(0,3)
            }else{
                return datalist2
            }
        }
    },
    methods:{
        async showEditDetail(val){
            await setTimeout(()=>{
                this.sindx++;
                this.newDatalist.map(item=>{
                    if(val === 'open'){
                        item._expanded = true;
                    }else{
                        item._expanded = false;
                    }
                })
                this.isShowEditDetail = !this.isShowEditDetail;
            },0);
        },
        async showDetail(){
            await setTimeout(()=>{
                this.sindx++;
                this.dataList.map(item=>{
                    item._expanded = !item._expanded
                })
                this.isShowDetail = !this.isShowDetail;
            },0);
        },
        // 删除单条
        deleteProject(json,index){
            this.sindx++;
            let aindex;
            let ajson = this.newDatalist.filter((item,bindex)=>{
                if(item.value === json.orderType){
                    aindex = bindex
                }
                return item.value === json.orderType
            })[0]
            ajson.items.splice(index,1)
            this.$set(this.newDatalist,aindex,ajson)
        },
        getType(val){
            let name = this.getOrderList.filter(item=>{
                return item.value === val
            })[0]
            return name.label
        },
        getCostName(val){
            let name = this.categoryList.filter(item=>{
                return item.value === val.billingCategoryId
            })[0]
            if(name){
                return name.label
            }
        },
        getDetail(){
            this.newDatalist = this.getOrderList.concat();
            this.newDatalist.map(item=>{
                item._expanded = true;
            })
            if(this.type == 'add') return;
            
            this.loading = true;
            HttpQueryValuationOne({id:this.id}).then(res=>{
                this.sindx++;
                this.loading = false;
                this.formData.code = res.data.code;
                this.formData.name = res.data.name;
                this.formData.description = res.data.description;
                // 查看时的数据展示,把现有的数据匹配进去
                this.dataList = res.data.billingPlanCategoryList;
                this.dataList.map(item=>{
                    item._expanded = true;
                })
                if(this.type !='add'){
                    this.newDatalist.map(item=>{
                        this.dataList.map(json=>{
                            if(item.value === json.orderType){
                                item._expanded = true;
                                item.items = json.items;
                            }
                        })
                    })
                }
                // 编辑创建时的数据展示
                this.openValue = this.dataList.map(item=>{
                    return this.getType(item.orderType)
                })
                // console.log(this.openValue)
            },err=>{
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                this.loading = false;
            })
        },
        clickProject(dataitem,index){
            this.newarr.map(item=>{
                delete item.ischeck
            })
            // $event.stopPropagation();
            this.chooseIndex = index;
            this.checkProject = dataitem.value;
            // 做成弹框形式选择
            this.modalProps = {
                show:true,
                title:this.getType(dataitem.value),
                chooseItem:dataitem,
                width:500,
                component:'compLine',
                linelist:this.newarr,
                chooselist:this.newDatalist,
                showFooter:false,
                on:{
                    'on-update':(list)=>{
                        this.sindx++;
                        // 判断修改的值在不在数组里面，存在就修改，不存在就添加
                        let ajson = this.newDatalist.filter(item=>{
                            return item.value === this.checkProject
                        })[0]

                        if(ajson){
                            ajson._expanded = true;
                            ajson.items = list
                        }else{
                            let dataone={
                                orderType:this.checkProject,
                                items:list,
                                _expanded:true,
                            }
                            this.newDatalist.push(dataone)
                        }
                        this.modalProps = {}
                        
                    },
                    'on-close':()=>{
                        this.modalProps = {}
                    }
                }
            }
            
        },
        async submit(){
            // 判断必填
            const valid = await this.$refs.validForm.validate()
            if(!valid) return;
            // 判断是否选中
            if(this.newDatalist.length===0){
                this.$Message.error('方案配置不能为空！');
                return;
            }

            // 在这里做一次转换
            this.billingPlanCategoryList = []
            
            this.newDatalist.map(item=>{
                if(item.items){
                    let dataone = {
                        orderType:item.value,
                        items:item.items
                    }
                    this.billingPlanCategoryList.push(dataone)
                }
            })
            HttpSaveValuationOne({
                id:this.id,
                name:this.formData.name,
                description:this.formData.description,
                billingPlanCategoryList:this.billingPlanCategoryList
            }).then(res=>{
                this.$Message.success(res.message);
                this.cancel()
            },err=>{
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$router.push({ name: "tasksValuation" })
        }
    }
}
</script>